import axios from "axios";
import { logout } from "../redux/slices/authSlice";
import { showLoginModal } from "../redux/slices/uiSlice";
import { store } from "../redux/store";

// Create an Axios instance with base configuration
const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Variable to store authentication token
let authToken = null;

// Function to set the authentication token
export const setAuthToken = (token) => {
  authToken = token;
};

// Request interceptor to add auth token to headers
API.interceptors.request.use(
  (config) => {
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for global error handling
API.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized errors
    if (
      error.response?.status === 401 &&
      error.response.data.message === "Unauthenticated."
    ) {
      const currentPath = window.location.pathname;

      // Dispatch logout action to clear auth state
      store.dispatch(logout());

      // Redirect to admin login if on admin route, else show login modal
      if (currentPath.startsWith("/admin")) {
        window.location.href = "/admin";
      } else {
        store.dispatch(showLoginModal(true));
      }
    }

    return Promise.reject(error);
  }
);

// API request methods wrapper
export const request = {
  // GET request
  get: (url, config = {}) => API.get(url, config).then((res) => res.data),
  // POST request
  post: (url, data = {}, config = {}) =>
    API.post(url, data, config).then((res) => res.data),
  // PUT request
  put: (url, data = {}, config = {}) =>
    API.put(url, data, config).then((res) => res.data),
  // DELETE request
  delete: (url, config = {}) => API.delete(url, config).then((res) => res.data),
  // POST request for multipart/form-data
  postMultipart: (url, formData, config = {}) =>
    API.post(url, formData, {
      headers: {
        ...config.headers,
        "Content-Type": "multipart/form-data",
      },
      ...config,
    }).then((res) => res.data),
};
